import { getSingularRoleTitle } from "@src/utils/data/roles.utils";
import { SelectInputData } from "../../../../../components/deprecated/SelectInputField/SelectInputField";
import { Role } from "../../../User/Role";
import { DataObjectType } from "../../DataObjects/DataObjectHelper";
import { FirebaseDataSelectField, FirebaseDataSelectFieldOption } from "../Generic/FirebaseDataSelectField";

export class PropertyMemberRolesFields<FirebaseDataType extends DataObjectType> extends FirebaseDataSelectField<Role, FirebaseDataType> {
  override encode = (value: Role) => value.id;
  override convertValueToSelectInput(value: Role): SelectInputData {
    return new SelectInputData(value.id + "", getSingularRoleTitle(value.id, undefined));
  }
  override getValueForKey(key: string): Role | undefined {
    return !isNaN(parseInt(key)) ? Role.getRoleWithId(parseInt(key)) : undefined;
  }
  override getOptions(): FirebaseDataSelectFieldOption[] {
    return [Role.LANDLORD, Role.RENTER, Role.ENTREPRENEUR].map((role) => {
      return {
        key: role.id + "",
        label: getSingularRoleTitle(role.id, undefined),
      };
    });
  }
  override getReadableStringRepresentation(value: Role): string {
    return getSingularRoleTitle(value.id, undefined);
  }
  override decodeStringAsRawValue = () => true;

  override isValueValid = (value: any): boolean => {
    return value instanceof Role;
  };
}

